teamHandler = {
    $panelTeams = $('.panel-teams'),  
    $teamThumbnail = $('.team-thumbnail'),
    $openTeamBio = $('.item-team'),
    $closeTeamBio = $('.close-team-bio'),
    $window = $(window),
    isOnLoad = false,
    lastWindowWidth = $window.width(),
    resizeTimeout = null,
    
    init = function(){
        var self = this;
        this.isOnLoad = true;
        var $teamsItemContainer = this.$panelTeams.find('.teams-item-container');
        var $title = $teamsItemContainer.find('.title');

        animateHandler.animateScroll( $title ); 
        animateHandler.animateParallax( $teamsItemContainer );
               
        self.$teamThumbnail.each(function() {
            var width = $(this).outerWidth();
            var newHeight = (width / 2) * 2.5;

            $(this).css({
                'height' : newHeight,
            });
        });

        self.$openTeamBio.on('click', function() {
            $('header').addClass('reveal-open');
        });

        self.$closeTeamBio.on('click', function() {
            $('header').removeClass('reveal-open');
        });

        this.$window.resize(function(){
            clearTimeout(self.resizeTimeout);
            self.resizeTimeout = setTimeout(function() {
                if (self.isOnLoad) {
                    self.isOnLoad = false;   
                } else {
                    var windowWidth = $window.width();
                    if (windowWidth != self.lastWindowWidth) {
                        animateHandler.animateScroll( $title, 1, true ); 
                        self.lastWindowWidth = windowWidth;
                    }
                }   
            }, 25);
        });
    }
}